import { z } from 'zod';

import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';

export const getSchema = ({ t }) => {
  return z
    .object({
      number: z
        .string({ message: t('inputs:required') })
        .trim()
        .min(1, t('inputs:required'))
        .max(40, t('errors:max', { count: 40 })),
      message: z
        .string()
        .max(160, t('errors:max', { count: 160 }))
        .optional(),
    })
    .merge(getGeneralStaticBuilderSchema());
};
